module.exports = __webpack_public_path__ + "static/media/178279B.0bb01f11.jpg";